import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { MarkdownToHtmlConverter } from 'ui/MarkdownToHtmlConverter';
import { COLORS } from 'services/constants/colors';
import { THintsItemProps } from './types';

export const HintsItem: FC<THintsItemProps> = ({ hint }) => {
	return (
		<Box
			sx={{
				borderRadius: '12px',
				padding: '10px',
				backgroundColor: COLORS.SECONDARY,
				// color: 'primary.main',
			}}
		>
			<Typography
				sx={{
					// fontWeight: 'bold',
					marginBottom: '10px',
				}}
				component="div"
				color="primary"
			>
				{/* {hint} */}
				<MarkdownToHtmlConverter markdownText={hint} />
			</Typography>
		</Box>
	);
};
